import { useRecoilValue, useSetRecoilState } from "recoil";
import { loginState } from "../../stores/loginState";
import { useMutation } from "react-query";
import {
  HandexInstance,
  HanjinInstance,
  KpcInstance,
  LogenInstance,
  LotteInstance,
} from "../instance";
import dayjs from "dayjs";
import { barcodeDataState } from "../../stores/barcode/barcodeDataState";
import Swal from "sweetalert2";
import { kpcScanPaginationState } from "../../stores/barcode/kpcScanPaginationState";
import { isKpcCompany, normalizeKpcScanItem } from "../../utils/kpc";

// 운송장 조회 API
const useGetBarcodeData = ({ startDate, endDate, workType, barcode, resultCode, page = 0, size = 50 }) => {
  const login = useRecoilValue(loginState);
  const setBarcodeData = useSetRecoilState(barcodeDataState);
  const setKpcPagination = useSetRecoilState(kpcScanPaginationState);

  // 조회 조건에 맞는 데이터만 필터링
  const filterData = (data) => {
    return data
      .filter((item) => {
        const itemDate = dayjs(item.scandate).format("YYYY-MM-DD");
        const matchesDate = itemDate >= startDate && itemDate <= endDate;
        const matchesWorkType = workType === "전체" || item.tm_dv === workType;
        const matchesBarcode = !barcode || item.barcode.includes(barcode);

        const matchesResultCode =
          resultCode === "전체" || String(item.result_no) === resultCode;

        return matchesDate && matchesWorkType && matchesBarcode && matchesResultCode;
      })
      .map((item) =>
        isKpcCompany(login.company)
          ? normalizeKpcScanItem(item)
          : {
              ...item,
              result_no: item.result_no || "",
              result_msg: item.result_msg || "",
              scannername: item.scannername || "",
            },
      );
  };

  const mutationOptions = {
    onSuccess: (data) => {
      if (data.result === "00" || data.result === "77") {
        const kpcData = data.data || {};
        const sourceData = isKpcCompany(login.company)
          ? kpcData.items || []
          : data.data;
        const filteredData = filterData(sourceData);
        setBarcodeData(filteredData);

        if (isKpcCompany(login.company)) {
          setKpcPagination({
            totalCount: Number(kpcData.totalCount) || 0,
            page: Number(kpcData.page) || 0,
            size: Number(kpcData.size) || size,
          });
        }
        Swal.fire({
          icon: "success",
          title: "운송장 데이터를 조회했습니다.",
          confirmButtonText: "확인",
        });
      }
    },
    onError: (error) => {
      Swal.fire({
        icon: "warning",
        title: "운송장 데이터를 조회하는 중 문제가 발생했습니다.",
        confirmButtonText: "확인",
      });
      console.log(error);
    },
  };

  const postData = {
    api: "dvInAll",
    data: [
      {
        start_time: `${dayjs(startDate).format("YYYY-MM-DD")} 00:00:00`,
        end_time: `${dayjs(endDate).format("YYYY-MM-DD")} 23:59:59`,
        bran_cd: login.branchCode,
        longTime: "",
        car_num: "",
        company: login.company,
      },
    ],
  };

  let mutationFn;

  if (login.company === "LOGEN") {
    mutationFn = () => LogenInstance.post("/lose", postData);
  } else if (login.company === "LOTTE") {
    mutationFn = () => LotteInstance.post("/lose", postData);
  } else if (login.company === "HANJIN") {
    mutationFn = () => HanjinInstance.post("/lose", postData);
  } else if (login.company === "HANDEX") {
    mutationFn = () => HandexInstance.post("/lose", postData);
  } else if (login.company === "KPC") {
    // KPC는 세션 점소를 사용하고 스캔 원장은 GET 쿼리 방식으로 조회한다.
    mutationFn = (request = {}) =>
      KpcInstance.get("/customer/scans", {
        params: {
          startDate,
          endDate,
          page: request.page ?? page,
          size: request.size ?? size,
        },
      });
  } else {
    mutationFn = () => {
      Swal.fire({
        icon: "warning",
        title: "고객사가 올바르지 않습니다.",
        confirmButtonText: "확인",
      });
    };
  }

  return useMutation("getAmount", mutationFn, mutationOptions);
};

export default useGetBarcodeData;
